export const DEBUG = true;

// 全局配置api服务器域名


export const pageServerTest = encodeURI("http://testapi.haimaotv.com");
// export const pageServerTest = encodeURI("https://qapi-moss.huan.tv");

export const pageServer = DEBUG ? pageServerTest : encodeURI("https://qapi-moss.huan.tv");

export const versionmb = "huanshiting";

export const wxappidTest = "wx5d11a563a1d8156a"  //测试
export const wxappid = "wx3504f817e2502fe9"  //欢视厅




/**
 * 设置cookie
 * @param name cookie的名称
 * @param value cookie的值
 * @param day cookie的过期时间
 */
export function setCookie(name, value, day) {
    if (day !== 0) { //当设置的时间等于0时，不设置expires属性，cookie在浏览器关闭后删除
        let expires = day * 24 * 60 * 60 * 1000;
        let date = new Date(+new Date() + expires);
        document.cookie = name + "=" + escape(value) + ";expires=" + date.toUTCString();
    } else {
        document.cookie = name + "=" + escape(value);
    }
};

/**
 * 获取对应名称的cookie
 * @param name cookie的名称
 * @returns {null} 不存在时，返回null
 */
export function getCookie(name) {
    let arr;
    let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
};

export function getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(;&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

// 导入自定义的https请求模块
import https from './https.js';

/**
 * 获取初始化web sessionId
 * 调用接口初始化会话ID，获取成功后自动存储到localStorage中
 * @returns {Promise} 返回Promise对象，成功时resolve sessionId，失败时reject错误信息
 */
export function getInitSessionId() {
    return new Promise((resolve, reject) => {
        // 构建API请求参数
        const requestData = {
            method: 'POST',
            url: '/api/superc/xiaoyou/web/session/init',
            headers: {
                'Content-Type': 'application/json'
            }
        };

        // 使用自定义的https模块发送POST请求获取sessionId
        https.request(requestData)
            .then(data => {
                // 检查业务状态码
                if (data.code === 0) {
                    // 成功获取sessionId，存储到localStorage
                    const sessionId = data.data;
                    localStorage.setItem('xiaoyou_session_id', sessionId);
                    console.log('SessionId已存储到localStorage:', sessionId);
                    resolve(sessionId);
                } else {
                    // 业务逻辑错误
                    reject(new Error(data.message || '获取sessionId失败'));
                }
            })
            .catch(error => {
                // 网络错误或其他异常
                console.error('获取初始化sessionId失败:', error);
                reject(error);
            });
    });
}

/**
 * 从localStorage获取已存储的sessionId
 * @returns {string|null} 返回sessionId字符串，如果不存在则返回null
 */
export function getStoredSessionId() {
    return localStorage.getItem('xiaoyou_session_id');
}

/**
 * 清除localStorage中存储的sessionId
 * 用于用户登出或重新初始化时清理旧的会话ID
 */
export function clearStoredSessionId() {
    localStorage.removeItem('xiaoyou_session_id');
    console.log('已清除localStorage中的sessionId');
}

/**
 * 根据投屏码获取设备信息
 * @param {string} code - 投屏码
 * @returns {Promise} 返回设备信息的Promise
 */
export function getDeviceByCode(code) {
    // 参数验证
    if (!code || typeof code !== 'string') {
        console.error('getDeviceByCode: 投屏码参数无效')
        return Promise.reject(new Error('投屏码参数无效'))
    }

    console.log('正在根据投屏码获取设备信息:', code)

    try {
        // 调用 POST 接口获取设备信息
        return https.request({
            // url: `/api/superc/xiaoyou/web/device/getByCode/${code}`,
            url:`/api/superc/xiaoyou/tvCode/getDevice`,
            method: 'POST',
            data: {
                "data": code
            }
        }).then(response => {
            let resData ={}
            console.log('获取设备信息成功:', response)
            if (response.data && Object.keys(response.data).length > 0) {
                let deviceInfo = JSON.parse(JSON.stringify(response.data.deviceInfo));
                console.log('123123123123',deviceInfo)
                let data = {
                    "deviceId": deviceInfo.devicedum,
                    "deviceName": `小柚投屏(${deviceInfo.buildBrand})`,
                    "onlineState": true,
                    "code":code,
                    "auth":false
                }
                localStorage.setItem('historyDeviceInfo',JSON.stringify(data))
                 resData = {
                    online: true,
                    ...response.data
                }
            } else {
                localStorage.removeItem('historyDeviceInfo')
                localStorage.removeItem('xiaoyou_session_id')
                 resData = {
                    online: false
                }
            }
            return resData
        }).catch(error => {
            console.error('获取设备信息失败:', error)
            throw error
        })
    } catch (error) {
        console.error('getDeviceByCode 调用异常:', error)
        return Promise.reject(error)
    }
}

/**
 * Web端请求握手
 * @param {string} deviceId - 设备ID
 * @param {string} sessionId - 会话ID
 * @returns {Promise} 返回握手请求结果的Promise
 */
export function requestHandshake(deviceId, sessionId) {
    console.log('正在发起握手请求:', { deviceId, sessionId })

    try {
        // 调用握手请求接口
        return https.request({
            url: '/api/superc/xiaoyou/web/device/requestHandshake',
            method: 'POST',
            data: {
                deviceId: deviceId || '',
                sessionId: sessionId || ''
            }
        }).then(response => {
            console.log('握手请求成功:', response)
            return response
        }).catch(error => {
            console.error('握手请求失败:', error)
            throw error
        })
    } catch (error) {
        console.error('requestHandshake 调用异常:', error)
        return Promise.reject(error)
    }
}

/**
 * TV端响应握手（轮询检查）
 * @param {string} deviceId - 设备ID
 * @param {string} sessionId - 会话ID
 * @returns {Promise} 返回握手响应结果的Promise
 */
export function respondHandshake(deviceId, sessionId) {
    console.log('正在检查握手响应:', { deviceId, sessionId })

    try {
        // 调用握手响应检查接口
        return https.request({
            url: '/api/superc/xiaoyou/web/device/pollStatus',
            method: 'POST',
            data: {
                deviceId: deviceId || '',
                sessionId: sessionId || ''
            }
        }).then(response => {
            console.log('握手响应检查结果:', response)
            return response
        }).catch(error => {
            console.error('握手响应检查失败:', error)
            throw error
        })
    } catch (error) {
        console.error('respondHandshake 调用异常:', error)
        return Promise.reject(error)
    }
}

/**
 * 调用转换请求体接口
 * 解析URL并转换为路由参数
 * @param {string} url - 需要转换的URL地址
 * @returns {Promise} 返回Promise对象，成功时resolve转换结果，失败时reject错误信息
 */
export function parseRouteUrl(url) {
    return new Promise((resolve, reject) => {
        // 构建API请求参数
        const requestData = {
            method: 'POST',
            url: '/api/v1/zero/superc/web/route/parse',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                url: url // 将URL作为请求体发送
            }
        };

        // 使用自定义的https模块发送POST请求
        https.request(requestData)
            .then(data => {
                // 检查业务状态码
                if (data.code === 0) {
                    // 成功获取转换结果
                    console.log('URL转换成功:', data.data);
                    resolve(data.data);
                } else {
                    // 业务逻辑错误
                    console.error('URL转换失败:', data.message);
                    reject(new Error(data.message || 'URL转换失败'));
                }
            })
            .catch(error => {
                // 网络错误或其他异常
                console.error('调用转换请求体接口失败:', error);
                reject(error);
            });
    });
}
/**
 * 获取网页标题
 * 通过URL获取网页的标题信息
 * @param {string} url - 需要获取标题的网页URL
 * @returns {Promise} 返回Promise对象，成功时resolve网页标题，失败时reject错误信息
 */
export function getWebTitle(url) {
    return new Promise((resolve, reject) => {
        // 构建API请求参数
        const requestData = {
            method: 'POST',
            url: '/api/v1/zero/superc/web/route/webTitle',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                url: url // 传递URL参数
            }
        };

        // 使用自定义的https模块发送POST请求
        https.request(requestData)
            .then(data => {
                // 检查业务状态码
                if (data.code === 0) {
                    // 成功获取网页标题
                    let title = data.data || '';
                    // 限制标题长度最多32位，超出则截取前32位
                    if (title.length > 32) {
                        title = title.substring(0, 32);
                        console.log('网页标题超过32位，已截取:', title);
                    }
                    console.log('获取网页标题成功:', title);
                    resolve(title);
                } else {
                    // 业务逻辑错误
                    console.error('获取网页标题失败:', data.message);
                    reject(new Error(data.message || '获取网页标题失败'));
                }
            })
            .catch(error => {
                // 网络错误或其他异常
                console.error('调用获取网页标题接口失败:', error);
                reject(error);
            });
    });
}

/**
 * 发送消息到TV端
 * 通过web端推送消息到tv端设备
 * @param {Object} messageData - 推送消息的数据对象
 * @param {string} messageData.action - 动作类型
 * @param {Object} messageData.additionalFields - 附加字段
 * @param {string} messageData.appIcon - 快应用图标
 * @param {string} messageData.appName - 快应用名称
 * @param {string} messageData.dataType - 数据类型
 * @param {string} messageData.deviceId - 推送目标设备ID
 * @param {string} messageData.extendParam - 扩展参数
 * @param {string} messageData.packageName - 要打开的应用包名
 * @param {string} messageData.page - 快应用页面
 * @param {string} messageData.param - 参数
 * @param {string} messageData.pushTitle - 短标题
 * @param {string} messageData.pushUrl - 推送URL
 * @param {number} messageData.splash - splash参数
 * @param {string} messageData.tvChannel - 电视渠道
 * @returns {Promise} 返回Promise对象，成功时resolve推送结果，失败时reject错误信息
 */
export function sendTvMsg(messageData) {
    return new Promise((resolve, reject) => {
        // 构建API请求参数
        const requestData = {
            method: 'POST',
            url: '/api/superc/xiaoyou/web/device/push',
            headers: {
                'Content-Type': 'application/json'
            },
            data: messageData // 直接传递消息数据对象
        };

        // 使用自定义的https模块发送POST请求
        https.request(requestData)
            .then(data => {
                // 检查业务状态码
                // if (data.code === 0) {
                    // 成功发送消息到TV端
                    console.log('消息推送到TV端成功:', data.data);
                    resolve(data.data);
                // } else {
                //     // 业务逻辑错误
                //     console.error('消息推送到TV端失败:', data.message);
                //     reject(new Error(data.message || '消息推送失败'));
                // }
            })
            .catch(error => {
                // 网络错误或其他异常
                console.error('调用发送消息接口失败:', error);
                reject(error);
            });
    });
}

/**
 * 获取微信SDK配置
 * 调用后端接口获取jsapi_ticket等配置信息
 * @returns {Promise} 返回包含微信SDK配置的Promise对象
 */
export function getWeChatSDKConfig() {
    return new Promise((resolve, reject) => {
        // 构建请求数据
        const requestData = {
            url: '/api/superc/xiaoyou/mini/getTicket', // 获取jsapi_ticket的接口地址
            method: 'POST', // 请求方式
            data: {
                url: window.location.href // 传递当前页面URL（去除hash部分）
                // url: window.location.href.split('?')[0] // 传递当前页面URL（去除hash部分）
            }
        };
        
        console.log('开始获取微信SDK配置:', requestData);
        
        // 使用自定义的https模块发送POST请求
        https.request(requestData)
            .then(data => {
                // 检查业务状态码
                if (data.code === 0) {
                    // 成功获取微信SDK配置
                    console.log('获取微信SDK配置成功:', data.data);
                    
                    // 解析返回的配置数据
                    // 假设后端返回的data是包含微信配置的对象
                    const config = {
                        appId:data.data.appId, // 微信公众号AppID
                        timestamp: data.data.timestamp, // 时间戳
                        nonceStr: data.data.nonceStr, // 随机字符串
                        signature: data.data.signature, // 签名
                        // jsApiList: ['wx-open-launch-weapp'] // 需要使用的JS接口列表
                        jsApiList:['getNetworkType']
                    };
                    
                    resolve(config);
                } else {
                    // 业务逻辑错误
                    console.error('获取微信SDK配置失败:', data.message);
                    reject(new Error(data.message || '获取微信SDK配置失败'));
                }
            })
            .catch(error => {
                // 网络错误或其他异常
                console.error('调用获取微信SDK配置接口失败:', error);
                reject(error);
            });
    });
}

/**
 * 获取微信JSSDK Ticket
 * 专门用于获取jsapi_ticket的简化方法
 * @returns {Promise} 返回包含ticket信息的Promise对象
 */
export function getWeChatTicket() {
    return new Promise((resolve, reject) => {
        // 构建请求数据
        const requestData = {
            url: '/api/superc/xiaoyou/mini/getTicket', // 获取jsapi_ticket的接口地址
            method: 'POST', // 请求方式
            data: {} // 根据接口文档，暂无请求参数
        };
        
        console.log('开始获取微信JSSDK Ticket:', requestData);
        
        // 使用自定义的https模块发送POST请求
        https.request(requestData)
            .then(data => {
                // 检查业务状态码
                if (data.code === 0) {
                    // 成功获取ticket
                    console.log('获取微信JSSDK Ticket成功:', data.data);
                    resolve(data.data);
                } else {
                    // 业务逻辑错误
                    console.error('获取微信JSSDK Ticket失败:', data.message);
                    reject(new Error(data.message || '获取微信JSSDK Ticket失败'));
                }
            })
            .catch(error => {
                // 网络错误或其他异常
                console.error('调用获取微信JSSDK Ticket接口失败:', error);
                reject(error);
            });
    });
}


// export default {
//     // DEBUG,
//     // apiServer,
//     pageServer,
//     setCookie,
//     getCookie,
//     getQueryString,
//     versionmb,
//     wxappidTest,
//     wxappid,
// }








// WEBPACK FOOTER //
// ./src/util.js